import en from 'vuetify/es5/locale/en';
import ru from 'vuetify/es5/locale/ru';
import zh from 'vuetify/es5/locale/zh-Hans';
import zht from 'vuetify/es5/locale/zh-Hant'; // 繁体中文
import uk from 'vuetify/es5/locale/uk';
import tr from 'vuetify/es5/locale/tr';
import th from 'vuetify/es5/locale/th';
import sv from 'vuetify/es5/locale/sv';
import sr from 'vuetify/es5/locale/sr-Cyrl';
import sl from 'vuetify/es5/locale/sl';
import ro from 'vuetify/es5/locale/ro';
import pt from 'vuetify/es5/locale/pt';
import pl from 'vuetify/es5/locale/pl';
import no from 'vuetify/es5/locale/no';
import nl from 'vuetify/es5/locale/nl';
import lv from 'vuetify/es5/locale/lv';
import lt from 'vuetify/es5/locale/lt';
import ko from 'vuetify/es5/locale/ko';
import ja from 'vuetify/es5/locale/ja';
import it from 'vuetify/es5/locale/it';
import index from 'vuetify/es5/locale/index';
import id from 'vuetify/es5/locale/id';
import hu from 'vuetify/es5/locale/hu';
import hr from 'vuetify/es5/locale/hr';
import he from 'vuetify/es5/locale/he';
import fr from 'vuetify/es5/locale/fr';
import fa from 'vuetify/es5/locale/fa';
import et from 'vuetify/es5/locale/et';
import es from 'vuetify/es5/locale/es';
import el from 'vuetify/es5/locale/el';
import de from 'vuetify/es5/locale/de';
import cs from 'vuetify/es5/locale/cs';
import ca from 'vuetify/es5/locale/ca';
import ar from 'vuetify/es5/locale/ar';
import af from 'vuetify/es5/locale/af';

const locales = { en, ru, zh };

export default locales;
